/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Tile_MinutesInputs */

const en_us2_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of training`)
};

const pt_br2_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de treino`)
};

const es_419_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de entrenamiento`)
};

const pt_pt2_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de treino`)
};

const fr_fr2_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`d'entraînement`)
};

const de_de2_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const it_it2_wrapped_tile_minutes = /** @type {(inputs: Wrapped_Tile_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di allenamento`)
};

/**
* | output |
* | --- |
* | "of training" |
*
* @param {Wrapped_Tile_MinutesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_tile_minutes = /** @type {((inputs?: Wrapped_Tile_MinutesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Tile_MinutesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_tile_minutes(inputs)
	if (locale === "es-419") return es_419_wrapped_tile_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_tile_minutes(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_tile_minutes(inputs)
	if (locale === "de-DE") return de_de2_wrapped_tile_minutes(inputs)
	if (locale === "it-IT") return it_it2_wrapped_tile_minutes(inputs)
	return en_us2_wrapped_tile_minutes(inputs)
});
export { wrapped_tile_minutes as "wrapped.tile_minutes" }